import React, {useCallback} from 'react';
import {css} from '@emotion/react';
import {Modal, PrimaryButton, SecondaryButton} from '../../components';
import {connect} from 'react-redux';
import * as Actions from '../../store/actions';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {deleteWebhookSubscription} from '../../requests/queries/Developers/webbhook';

function DeleteModal({open, bodyText, params, setOpen}) {
  const queryClients = useQueryClient();

  const {mutate, isLoading} = useMutation(deleteWebhookSubscription);
  const handleModalDelete = useCallback(async () => {
    try {
      if (params) {
        await mutate(params, {
          onSuccess: () => {
            queryClients.invalidateQueries();
            setOpen(false);
          },
          onError: error => {
            toast.error(error?.response?.data?.error);
          },
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [mutate, params, queryClients, setOpen]);

  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Are you sure?"
    >
      <div>
        <p className="mt-4 text-sm text-left text-body px-6">{bodyText}</p>

        <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
          <SecondaryButton
            className="w-[50%] !h-10"
            buttonText="Cancel"
            onClick={() => setOpen(false)}
          />{' '}
          <PrimaryButton
            className="w-[50%] !h-10 bg-danger"
            onClick={handleModalDelete}
            buttonText="Delete"
            loading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}

export default connect(state => state, Actions)(DeleteModal);
